import { render, staticRenderFns } from "./ProductPnl.vue?vue&type=template&id=f40221c2&scoped=true&lang=pug"
import script from "./ProductPnl.vue?vue&type=script&lang=js"
export * from "./ProductPnl.vue?vue&type=script&lang=js"
import style0 from "./ProductPnl.vue?vue&type=style&index=0&id=f40221c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f40221c2",
  null
  
)

export default component.exports